import { TodoContainer } from "containers";

const App = () => {
  return <TodoContainer />;
};

export default App;
